import { useEffect, useState } from "react";

interface UseRememberMeOptions {
  storageKey: string; // localStorage 中存储的 key
}

interface UseRemeberMeResult {
  checked: boolean;
  setChecked: (value: boolean) => void;
}

/**
 * useRememberMe
 * 管理 checkbox 状态并同步到 localStorage
 */
export function useRememberMe({
  storageKey,
}: UseRememberMeOptions): UseRemeberMeResult {
  const [checked, setCheckedState] = useState<boolean>(false);

  // 初始化状态
  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (stored === null) {
      // localStorage 没有值，初始化为 false 并写入缓存
      localStorage.setItem(storageKey, "false");
      setCheckedState(false);
    } else {
      // 存在缓存，解析为 boolean
      setCheckedState(stored === "true");
    }
  }, [storageKey]);

  // 状态同步到 localStorage
  const setChecked = (value: boolean) => {
    setCheckedState(value);
    localStorage.setItem(storageKey, value.toString());
  };

  return { checked, setChecked };
}
